import React from 'react';
import { Link } from 'react-router';
import LogoPng from '../images/sonifi-logo.png';
import LogoWebp from '../images/sonifi-logo.webp';

const WbAppLogo = ({ onGoHome }) => (
  <div className="logo">
    <Link to="/" onClick={onGoHome}>
      <picture>
        <source srcSet={LogoWebp} type="image/webp" />
        <source srcSet={LogoPng} type="image/png" />
        <img alt="Wb Logo" src={LogoPng} />
      </picture>
    </Link>
  </div>
);

export default WbAppLogo;
